<template>
  <div id="contenedor-cambiar-password-usuario">
    <v-form
    v-model="formularioValido"
    ref="cambiarPasswordUsuario">
      <v-card>
        <v-card-title class="secondary--text">
          Cambiar Contraseña de Usuario
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            cols="12"
            v-model="usuario.password"
            label="Password"
            :rules="[mixReglas.requerido]">
          </custom-text-field>
          <custom-text-field
            cols="12"
            v-model="usuario.rePassword"
            label="Re-Password"
            :rules="[mixReglas.requerido]">
          </custom-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarUsuarioBasico"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixCatalogoUsuarios from './mixCatalogoUsuarios';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CambiarPasswordUsuario',
  mixins: [mixCatalogoUsuarios],
  props: {
    usuarioId: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      usuario: {
        password: '',
        rePassword: '',
      },
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.cambiarPasswordUsuario.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },

};
</script>

<style>

</style>
